const config = {
  ENVIRONMENT_NAME: 'dev',
  forwoodId: {
    URL: 'https://id.dev.platform.forwoodsafety.com',
    USER_TOKEN_URL: 'https://2v8si1bph1.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://o3g13f0hgd.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.dev.platform.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.dev.platform.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.dev.platform.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.dev.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://ff1aofwdkd.execute-api.us-west-2.amazonaws.com/dev'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
